;(function(w){
	function LightboxContenidoGaleria(element){
		
		var main_pic = $(element).find('.main-photo')[0];

		var holder_items = $(element).find('.thumbs-holder')[0];

		var caption = $(element).find('.caption')[0];

		var flecha_izq = $(element).find('.main-photo .thumbs-controls a')[0];
		var flecha_der = $(element).find('.main-photo .thumbs-controls a')[1];

		var thumbs_flecha_izq = $(element).find('.thumbs .thumbs-controls a')[0];
		var thumbs_flecha_der = $(element).find('.thumbs .thumbs-controls a')[1];
		

		var imagen_aux = new Image();


		var holder_pos = 0;
		var ancho_item = 0;
		var cant_items_visibles = 7;

		var actual = 0;
		
		var arr_items = [];

		$(element).find('.item-thumb').each(function(index){
			arr_items[index] = this;
			$(arr_items[index]).bind('click', onClickItem);
		})

		$(arr_items[actual]).addClass('active');

		$(flecha_izq).addClass('disabled');
		$(thumbs_flecha_izq).addClass('disabled');

		var url_img = $(arr_items[actual]).data('imagen');
		var texto = $(arr_items[actual]).data('text');

		onResize();

		new Hammer(main_pic).on("swipe", onSwipe);
		

		$(window).bind('resize', onResize);
		
		$(flecha_izq).bind('click', onClickFlechaIzq);
		$(flecha_der).bind('click', onClickFlechaDer);
		$(thumbs_flecha_izq).bind('click', onClickThumbsFlechaIzq);
		$(thumbs_flecha_der).bind('click', onClickThumbsFlechaDer);
		$(imagen_aux).bind('load', onLoadImageAux);
		$(element).bind('click', onClickMainPic);
		$(holder_items).bind('click', onClickHolderItems);

		function onClickItem(e){
			e.preventDefault();

			setContent($(this).index());
		
		}

		function setContent(id){
			
			if(id <= 0){
				$(flecha_izq).addClass('disabled');
			}else{
				$(flecha_izq).removeClass('disabled');
			}

			if(id >= arr_items.length - 1){
				$(flecha_der).addClass('disabled');
			}else{
				$(flecha_der).removeClass('disabled');
			}			

			if(id < 0 || id >= arr_items.length){
				return;
			}

			$(arr_items[actual]).removeClass('active');
			actual = id;
			$(arr_items[actual]).addClass('active');

			url_img = $(arr_items[actual]).data('imagen');
			texto = $(arr_items[actual]).data('text');

			imagen_aux.src = url_img;
			$(main_pic).addClass('loading');
			$(main_pic).find('.bg').css('background-image','none');
		}

		function onLoadImageAux(e){
			$(main_pic).removeClass('loading');
			$(main_pic).find('.bg').css('background-image','url('+url_img+')');
			$(caption).html(texto);
		}

		function onResize(e){
			if($(window).width() > 1050){
				cant_items_visibles = 7
			}else if($(window).width() > 640){
				cant_items_visibles = 5;
			}else{
				cant_items_visibles = 3;
			}

			ancho_item = Math.round($(main_pic).width()/cant_items_visibles);
			$(element).find('.item-thumb').css('width', ancho_item);
			$(holder_items).css('width', Math.ceil(ancho_item*arr_items.length)+20);

			moveHolderItems(holder_pos);
			
		}

		function onClickThumbsFlechaIzq(e){
			e.preventDefault();
			e.stopPropagation();

			moveHolderItems(holder_pos - 1);
		}

		function onClickThumbsFlechaDer(e){
			e.preventDefault();
			e.stopPropagation();
			
			moveHolderItems(holder_pos + 1);
		}

		function moveHolderItems(pos){
			if(arr_items.length <= cant_items_visibles){
				pos = 0;
				$(thumbs_flecha_der).addClass('disabled');
			}else{
				if(pos <= 0){
					pos = 0;
					$(thumbs_flecha_izq).addClass('disabled');
				}else{
					$(thumbs_flecha_izq).removeClass('disabled');
				}	

				if(arr_items.length - pos <= cant_items_visibles){
					pos = arr_items.length - cant_items_visibles;
					$(thumbs_flecha_der).addClass('disabled');
				}else{
					$(thumbs_flecha_der).removeClass('disabled');
				}
			}

			holder_pos = pos;

			$(holder_items).css('left', -holder_pos*ancho_item);
		}

		function onSwipe(e){
			if(e.deltaX > 0){
				setContent(actual - 1);
				//moveHolderItems(holder_pos - 1);	
			}else{
				setContent(actual + 1);
				//moveHolderItems(holder_pos + 1);
			}
		}

		function onClickFlechaIzq(e){
			e.preventDefault();
			e.stopPropagation();

			setContent(actual - 1);

		}

		function onClickFlechaDer(e){
			e.preventDefault();
			e.stopPropagation();

			setContent(actual + 1);
			
		}

		function onClickMainPic(e){
			Main.lightbox_imagen.mostrar(url_img, texto);
		}

		function onClickHolderItems(e){
			e.preventDefault();
			e.stopPropagation();
		}		
	}
	
	w.LightboxContenidoGaleria = LightboxContenidoGaleria;
})(window)